<template>
  <div>
    <v-card :class="mobile ? 'pa-0' : 'pa-5'">
      <v-card-title primary-title class="pl-5 text_title_2">
        {{
        WEB_LANGUAGE == "th"
        ? text.satisfaction_form_title.th
        : WEB_LANGUAGE == "en"
        ? text.satisfaction_form_title.en
        : "-"
        }}
      </v-card-title>
      <v-card-text class="text_body_3">
        <v-row>
          <v-col class="text_body_5">
            {{
            WEB_LANGUAGE == "th"
            ? text.satisfaction_explain.th
            : WEB_LANGUAGE == "en"
            ? text.satisfaction_explain.en
            : "-"
            }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn outlined color="primary" @click="openFeedbackDialog()">
          <v-icon class="mr-2">mdi-file-document</v-icon>
          <font class="text_body_5">
            {{
            WEB_LANGUAGE == "th"
            ? text.satisfaction_btn.th
            : WEB_LANGUAGE == "en"
            ? text.satisfaction_btn.en
            : "-"
            }}
          </font>
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog
      v-model="dialog_feedback"
      scrollable
      max-width="700px"
      transition="dialog-transition"
      :content-class="mobile ? 'mx-2 ' : ''"
    >
      <v-card>
        <v-card-title primary-title style="background-color:#e9f1fe" :class="mobile ? 'pa-3' : ''">
          <v-row>
            <v-col cols="12" align="center" justify="center">
              <font class="text_title_3" color="#0e62ed">
                {{
                WEB_LANGUAGE == "th"
                ? text.satisfaction_form_title.th
                : WEB_LANGUAGE == "en"
                ? text.satisfaction_form_title.en
                : "-"
                }}
              </font>
            </v-col>

            <v-col cols="12" align="center" justify="center" v-if="!mobile">
              <font class="text_body_5">
                {{
                WEB_LANGUAGE == "th"
                ? text.satisfaction_form_detail.th
                : WEB_LANGUAGE == "en"
                ? text.satisfaction_form_detail.en
                : "-"
                }}
              </font>
            </v-col>
            <v-col cols="12" align="center" justify="center" v-if="mobile" class="pb-0 mb-0">
              <font class="text_body_5">
                {{
                WEB_LANGUAGE == "th"
                ? text.satisfaction_form_detail_mobile_line1.th
                : WEB_LANGUAGE == "en"
                ? text.satisfaction_form_detail_mobile_line1.en
                : "-"
                }}
              </font>
            </v-col>
            <v-col cols="12" align="center" justify="center" v-if="mobile" class="pb-0 mb-0">
              <font class="text_body_5">
                {{
                WEB_LANGUAGE == "th"
                ? text.satisfaction_form_detail_mobile_line2.th
                : WEB_LANGUAGE == "en"
                ? text.satisfaction_form_detail_mobile_line2.en
                : "-"
                }}
              </font>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-col cols="12" align="center" justify="center" v-if="score_selected">
              <font class="text_title_1" color="#0e62ed">
                {{ score_selected }}
                {{
                WEB_LANGUAGE == "th"
                ? text.satisfaction_form_score_unit.th
                : WEB_LANGUAGE == "en"
                ? text.satisfaction_form_score_unit.en
                : "-"
                }}
              </font>
            </v-col>
            <v-col
              class="px-0"
              cols="2"
              align="center"
              justify="center"
              v-for="(item, index) in image_score"
              :key="index"
            >
              <v-btn
                :class="!mobile ? 'mx-3 my-5' : 'mx-1'"
                @click="score_selected = item.score"
                text
                fab
              >
                <v-avatar :size="!mobile ? '60' : '50'">
                  <img
                    :src="
                      score_selected == item.score
                        ? item.selected
                        : item.not_select
                    "
                    alt="suggestion_image"
                  />
                </v-avatar>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="pa-5">
          <v-row align="center" justify="center">
            <v-col cols="12" sm="10" md="8" align="start" justify="center">
              <font class="text_title_5">
                {{
                WEB_LANGUAGE == "th"
                ? text.suggestion.th
                : WEB_LANGUAGE == "en"
                ? text.suggestion.en
                : "-"
                }}
              </font>
              <v-textarea
                v-model="suggestion"
                name="suggestion"
                :placeholder="
                  WEB_LANGUAGE == 'th'
                    ? text.suggestion_placeholder.th
                    : WEB_LANGUAGE == 'en'
                    ? text.suggestion_placeholder.en
                    : '-'
                "
                id="suggestion"
                textarea
                outlined
                dense
              ></v-textarea>
            </v-col>
            <v-col cols="12" sm="10" md="8" align="end" justify="center">
              <v-btn color="primary" @click="sendFeedback()">
                <font class="text_title_5">
                  {{
                  WEB_LANGUAGE == "th"
                  ? text.submit_btn.th
                  : WEB_LANGUAGE == "en"
                  ? text.submit_btn.en
                  : "-"
                  }}
                </font>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import flag from "@/views/AppBehide/Settings/LanguageList.js";
import { bus } from "@/main";
import { text_searchHomePage } from "@/assets/javascript/dataLanguage.js";
export default {
  data() {
    return {
      WEB_LANGUAGE: "th",
      text: null,
      dialog_feedback: false,
      suggestion: "",
      header_token: {
        headers: {
          token: "token_inet_dev",
        },
      },
      score_selected: 0,
      image_score: [
        {
          selected: require("@/assets/emoji/1_selected.png"),
          not_select: require("@/assets/emoji/1_not_select.png"),
          score: 1,
        },
        {
          selected: require("@/assets/emoji/2_selected.png"),
          not_select: require("@/assets/emoji/2_not_select.png"),
          score: 2,
        },
        {
          selected: require("@/assets/emoji/3_selected.png"),
          not_select: require("@/assets/emoji/3_not_select.png"),
          score: 3,
        },
        {
          selected: require("@/assets/emoji/4_selected.png"),
          not_select: require("@/assets/emoji/4_not_select.png"),
          score: 4,
        },
        {
          selected: require("@/assets/emoji/5_selected.png"),
          not_select: require("@/assets/emoji/5_not_select.png"),
          score: 5,
        },
      ],
    };
  },
  computed: {
    mobile() {
      if (
        this.$vuetify.breakpoint.width >= 320 &&
        this.$vuetify.breakpoint.width < 768
      ) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (
        this.$vuetify.breakpoint.width >= 768 &&
        this.$vuetify.breakpoint.width < 1440
      ) {
        return true;
      } else {
        return false;
      }
    },
    desktop() {
      if (this.$vuetify.breakpoint.width >= 1440) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.text = text_searchHomePage;
    bus.$on("switchLanguage", (data) => {
      this.WEB_LANGUAGE = data;
    });
  },
  beforeDestroy() {
    bus.$off("switchLanguage");
  },
  methods: {
    openFeedbackDialog() {
      this.dialog_feedback = true;
      this.suggestion = "";
      this.score_selected = 0;
    },
    sendFeedback() {
      if (this.score_selected > 0) {
        let data = {
          comment: this.suggestion,
          point: this.score_selected,
        };
        this.axios
          .post(
            process.env.VUE_APP_API + "api/v1/feedback",
            data,
            this.header_token
          )
          .then((response) => {
            // console.log(response.data);
            if (response.data == "success") {
              this.$swal.fire({
                icon: "success",
                title:
                  this.WEB_LANGUAGE == "th"
                    ? this.text.swal_validate_title.th
                    : this.WEB_LANGUAGE == "en"
                    ? this.text.swal_validate_title.en
                    : "-",
                text:
                  this.WEB_LANGUAGE == "th"
                    ? this.text.swal_validate_text.th
                    : this.WEB_LANGUAGE == "en"
                    ? this.text.swal_validate_text.en
                    : "-",
                showConfirmButton: false,
                timer: 1000,
              });
            }
            this.dialog_feedback = false;
          })
          .catch((err) => {
            // console.log("api post feedback err");
          });
      } else {
        this.$swal.fire({
          icon: "warning",
          title:
            this.WEB_LANGUAGE == "th"
              ? this.text.swal_invalidate_title.th
              : this.WEB_LANGUAGE == "en"
              ? this.text.swal_invalidate_title.en
              : "-",
          text:
            this.WEB_LANGUAGE == "th"
              ? this.text.swal_invalidate_text.th
              : this.WEB_LANGUAGE == "en"
              ? this.text.swal_invalidate_text.en
              : "-",
          showConfirmButton: false,
          timer: 1000,
        });
      }
    },
  },
};
</script>
